enum ProactiveChatType {
    Store = "proactive-chat/STORE_PROACTIVE_CHAT",
    Toggle = "proactive-chat/TOGGLE_PROACTIVE_CHAT",
}

export default ProactiveChatType;
